import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SignalrService } from './signalr.service';

@Injectable({
  providedIn: 'root'
})
export class SignalrChatService extends SignalrService {

  constructor() {
    super(`${environment.apiUrl}hubs/chat`);
  }
}
